<template>
    <section :class="[
    	'block-wrapper', 
    	componentClass, 
    	colorMode, 
    	styleClasses,
    	{
    		visible: visible, 
    		ready: ready
    	}
    ]">
		<a v-if="data.component_id==='component-2'" @click.prevent="scrollNow" class="page-start-scroll-down" href="#" role="button"><i class="ruter-ficon-chevron-down"></i></a>
		<div class="row">
			<div class="columns small-12">
				<div class="row">
					<div ref="textColumn" :class="textColumns" 
						:style="{ 
							order: textOrder,
							minHeight: mediaWrapperHeight
						}">
						<wysiwyg-content ref="textWrapper" 
							:data="data.wysiwyg_content" 
							:columns="2" 
							:class="[{ 
								'center-vertically': verticallyCenterText
							}]"></wysiwyg-content>
					</div>
					<div :class="mediaColumns" :style="{ order: mediaOrder}">
						<media-content 
							ref="mediaWrapper" 
							:data="data.media_content" 
							:ready="ready" 
							v-on:heightChange="handleMediaHeightChange"></media-content>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>


<script>
import BaseBlock from './Base'
import WysiwygContent from './wysiwyg/Content'
import MediaContent from './media/Content'

export default {
    extends: BaseBlock,
	data() {
		return {
			textOrder: 1,
			mediaOrder: 2,
            defaultColorMode: 'light',
            mobileBreakpoint: 640,
            componentClass: 'text-wrapper text-and-media-wrapper',
			content() {
				if (this.type==='textbox') return this.textbox;
			},
			verticallyCenterText: false,
			mediaWrapperHeight: 0
		}
	},
	computed: {
		mediaColumns() {
			return 'media-column columns small-12 medium-5 large-4 large-offset-1 xxlarge-3 xxlarge-offset-2';
		},
		textColumns() {
			return 'text-column columns small-12 medium-7 large-5 xlarge-4 xlarge-offset-1';
		},
    	styleClasses() {
    		return this.data.styles || ''
    	}
	},
	methods: {
		adjustForWidthChange() {
			this.setFlexOrders()
			this.centerTextIfNeeded()
		},
		handleMediaHeightChange() {
			this.centerTextIfNeeded()
		},
		centerTextIfNeeded() {
			if (this.data.component_id==="component-2") return;
			if (window.innerWidth<=this.mobileBreakpoint) {
				this.mediaWrapperHeight = 0;
				this.verticallyCenterText = false;
			} else {
				if (typeof this.$el === 'undefined' || typeof this.$refs.mediaWrapper === 'undefined' || typeof this.$refs.textWrapper === 'undefined') {
					setTimeout(() => { this.centerTextIfNeeded() }, 750);
					return;
				}
				this.mediaWrapperHeight = this.$refs.mediaWrapper.$el.clientHeight;
				var textWrapperHeight = this.$refs.textWrapper.$el.clientHeight;
				this.verticallyCenterText = (this.mediaWrapperHeight>textWrapperHeight);
			}
		},
		setFlexOrders() {
			this.textOrder = ((window.innerWidth<=this.mobileBreakpoint) || ((window.innerWidth>=this.mobileBreakpoint) && (this.data.media_location!=='left'))) ? 1 : 2;
			this.mediaOrder = ((window.innerWidth<=this.mobileBreakpoint) || ((window.innerWidth>=this.mobileBreakpoint) && (this.data.media_location!=='left'))) ? 2 : 1;
		},
		scrollNow() {
			this.$scrollTo('component-2', 700);
		}
	},
	mounted() {
		this.adjustForWidthChange()
		window.addEventListener('resize', this.adjustForWidthChange)
	},
	destroy() {
		window.removeEventListener('resize', this.adjustForWidthChange)
	},
	components: {
		WysiwygContent,
		MediaContent
	}
}
</script>

<style lang="scss">
	@import "../../styles/scss/global/block-wrapper";
	@import "../../styles/scss/component/text";
	@import "../../styles/scss/component/text-and-media";
</style>